import { defineComponent } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73dcd72e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "judge-content"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import JudgeFilterBlock from '@/views/goodsManage/goodsJudge/components/JudgeFilterBlock.vue';
import JudgeTableBlock from '@/views/goodsManage/goodsJudge/components/JudgeTableBlock.vue';
const __default__ = defineComponent({
  name: 'goodsJudge'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const router = useRouter();
    const filterRef = ref(null);
    const tableRef = ref(null);
    const tableLoading = ref(false);
    const updateTableLoading = newValue => {
      tableLoading.value = newValue;
    };
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    const setProductName = e => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.setProductName(e);
    };
    const goDetail = (e, skuId) => {
      var _filterRef$value, _filterRef$value2;
      router.push({
        name: 'goodsSettingDetail',
        query: {
          dbtId: (_filterRef$value = filterRef.value) === null || _filterRef$value === void 0 ? void 0 : _filterRef$value.dbtId,
          prodChnl: (_filterRef$value2 = filterRef.value) === null || _filterRef$value2 === void 0 ? void 0 : _filterRef$value2.channel,
          type: 'watch',
          id: e,
          skuId: skuId
        }
      });
    }; // 跳转详情页
    const onUpdateStatistics = () => {
      var _filterRef$value3;
      (_filterRef$value3 = filterRef.value) === null || _filterRef$value3 === void 0 || _filterRef$value3.getStatistics();
    };
    // onActivated(() => {
    //   filterRef.value.filterSubmit()
    // })
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(JudgeFilterBlock, {
        ref_key: "filterRef",
        ref: filterRef,
        tableLoading: tableLoading.value,
        "onUpdate:tableLoading": updateTableLoading,
        onFilterSubmit: filterSubmit,
        onSetProductName: setProductName
      }, null, 8, ["tableLoading"]), _createVNode(JudgeTableBlock, {
        ref_key: "tableRef",
        ref: tableRef,
        "table-loading": tableLoading.value,
        "onUpdate:table-loading": _cache[0] || (_cache[0] = $event => tableLoading.value = $event),
        "onUpdate:tableLoading": updateTableLoading,
        onGoDetail: goDetail,
        onUpdateStatistics: onUpdateStatistics
      }, null, 8, ["table-loading"])]);
    };
  }
});